/**
 * Where the landing page's shop buttons lead: the sale, with the campaign code
 * in the URL (`/collections/sale?code=BLACKFRIDAY`). The `?code=` is what
 * applies it — every price on arrival is shown with the code deducted, and the
 * cart takes the code on its first line (see `plugins/3.urlCoupon`) — so the
 * button works on its own, whether or not the page's own pre-apply has run.
 *
 * A `?code=` link replaces whatever code the visitor holds without comparing
 * the two, so a visitor who kept a deeper code from another campaign (see
 * `adoptCampaignCode` on the page) gets the plain link and keeps it.
 */
export function useBlackFridayShopLink() {
  const { coupon } = useUrlCoupon()

  return computed(() => {
    const held = coupon.value
    return held && held.code !== BLACK_FRIDAY_CODE
      ? { path: BLACK_FRIDAY_SHOP_PATH }
      : { path: BLACK_FRIDAY_SHOP_PATH, query: { code: BLACK_FRIDAY_CODE } }
  })
}
